import React from 'react';
import ItemWithTooltip from './ItemWithTooltip';
import { ItemDotBlueComponent } from '../../ItemDotBlue';

type Props = {
  item: any;
  isSimple: boolean;
  isExpanded: boolean;
};

const DotBlueItem: React.FC<Props> = ({ item, isSimple, isExpanded }) => (
  <ItemWithTooltip item={item}>
    <ItemDotBlueComponent
      item={item}
      isSimple={isSimple}
      isExpanded={isExpanded}
    />
  </ItemWithTooltip>
);

export default DotBlueItem;
